export const TradeBreakpoint = 1170; // px, used in scss/_trade.scss

export const TRUNCATIONS: Record<string, Record<string, number[]>> = {
  BTC: {
    CBBTC: [1, 2, 3, 4, 5, 6, 7, 8],
    ETH: [2, 3, 4, 5, 6, 7, 8, 9],
    LQDY: [5, 6, 7, 8, 9, 10, 11, 12],
    RUNE: [5, 6, 7, 8, 9, 10, 11, 12],
    TCY: [5, 6, 7, 8, 9, 10, 11, 12],
    WBTC: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  ETH: {
    ETH: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  RUNE: {
    RUJI: [1, 2, 3, 4, 5, 6, 7, 8],
    TCY: [1, 2, 3, 4, 5, 6, 7, 8],
    bRUNE: [1, 2, 3, 4, 5, 6, 7],
  },
  USDC: {
    ATOM: [0, 1, 2, 3, 4, 5, 6, 7],
    AUTO: [3, 4, 5, 6, 7, 8, 9, 10],
    AVAX: [-1, 0, 1, 2, 3, 4, 5],
    BCH: [-2, -1, 0, 1, 2],
    BNB: [-2, -1, 0, 1, 2],
    BTC: [-4, -3, -2, -1, 0, 1, 2],
    DAI: [1, 2, 3, 4, 5, 6, 7],
    DOGE: [2, 3, 4, 5, 6, 7, 8, 9],
    ETH: [-3, -2, -1, 0, 1, 2],
    GUSD: [1, 2, 3, 4, 5, 6, 7],
    LQDY: [2, 3, 4, 5, 6, 7, 8, 9],
    LTC: [-1, 0, 1, 2, 3, 4, 5],
    NAMI: [3, 4, 5, 6, 7, 8, 9, 10],
    RUJI: [1, 2, 3, 4, 5, 6],
    RUNE: [1, 2, 3, 4, 5, 6, 7, 8],
    TCY: [1, 2, 3, 4, 5, 6, 7, 8],
    USDC: [1, 2, 3, 4, 5, 6, 7, 8],
    USDP: [1, 2, 3, 4, 5, 6, 7],
    USDT: [1, 2, 3, 4, 5, 6, 7],
    XRP: [1, 2, 3, 4, 5, 6, 7],
  },
  USDT: {
    BTC: [-4, -3, -2, -1, 0, 1, 2],
    ETH: [-3, -2, -1, 0, 1, 2],
    LTC: [-1, 0, 1, 2, 3, 4, 5],
  },
};
